import {
  faClock,
  faCogs,
  faEdit,
  faTasksAlt,
  faTicketAlt,
  faClipboardCheck,
  faUsers,
  faShieldAlt,
  faProjectDiagram,
  faVideo,
  faBolt,
  faUtilityPoleDouble,
  faFileLines,
  faLink,
  faListCheck,
} from '@fortawesome/pro-duotone-svg-icons';
import { faForklift } from '@fortawesome/pro-solid-svg-icons';
import CustomIcon from './customIcon/CustomIcon';

export const navItems = [
  {
    permission: 'maintenance:read',
    to: '/maintenance',
    icon: faCogs,
    displayText: 'Maintenance',
  },
  {
    to: '/digsafe',
    icon: faTicketAlt,
    displayText: 'Dig Safe',
    permission: 'digSafe:read',
  },
  {
    to: '/permits',
    icon: faClipboardCheck,
    displayText: 'Permits',
    permission: 'permits:read',
    //permission: "UNRELEASED:MODULE",
  },
  {
    to: '/employee',
    icon: faUsers,
    displayText: 'Employee',
    // permission: "employee:read",
    permission: 'UNRELEASED:MODULE',
  },
  {
    to: '/jobs',
    icon: faTasksAlt,
    displayText: 'Job Briefs',
    permission: 'jobBrief:read',
  },
  {
    to: '/prejobdiscovery',
    icon: faVideo,
    displayText: 'Pre-Job Discovery',
    permission: 'preJobDiscovery:read',
    //permission: "UNRELEASED:MODULE",
  },
  {
    to: '/timecards',
    icon: faClock,
    displayText: 'Timecards',
    permission: 'timeCards:read',
  },
  {
    to: '/equipment',
    icon: faForklift,
    displayText: 'Equipment',
    permission: 'equipments:read',
  },
  {
    permission: 'timeCardsSpecialProjects:read',
    to: '/specialprojects',
    icon: faProjectDiagram,
    displayText: 'Special Projects',
  },
  {
    to: '/fiftythirteen',
    customIcon: true,
    displayText: '5013',
    permission: 'fiftyThirteen:read',
  },
  {
    permission: 'materialIssue:read',
    to: '/safetytraining',
    icon: faShieldAlt,
    displayText: `Safety Training & QC`,
  },
  {
    permission: 'violationCar:read',
    to: '/cvac',
    icon: faShieldAlt,
    displayText: `CVAC`,
  },
  {
    permission: 'electroFusionAudits:read',
    to: '/electrofusionAudit',
    icon: faBolt,
    displayText: `Electro Fusion Audits`,
  },
  {
    permission: 'fusionQcForms:read', //TODO need a permissions entry in backend for the fuser forms "container" page?
    to: '/fuserforms',
    icon: faClipboardCheck,
    displayText: `Fuser Forms`,
  },
  {
    to: '/airtest',
    icon: faFileLines,
    customIcon: true,
    displayText: 'Air Test',
    permission: 'airTest:read',
  },
  {
    to: '/unmarkedutilities',
    icon: faUtilityPoleDouble,
    displayText: 'Unmarked/Mismarked Utilities',
    permission: 'unmarkedUtilities:read',
  },
  {
    to: '/cms',
    icon: faEdit,
    displayText: 'CMS',
    permission: 'cms:create',
  },
  {
    to: '/purchasing',
    icon: faListCheck,
    displayText: 'Purchasing',
    permission: 'poTracker:read',
  },
  {
    to: '/importantlinks',
    icon: faLink,
    displayText: 'Important Links',
    permission: 'importantLinks:read',
  },
];
